import * as React from "react";
import { _MasterDetailView, } from "../../generic/master-detail-view/MasterDetailView";
import { DetailViewInventory } from "./DetailViewInventory";
import { MasterViewBuildings } from "./MasterViewBuildings";
export var MasterDetailInventory = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewBuildings, detailRenderer: DetailViewInventory }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/MasterDetailInventory.tsx
// module id = 2738
// module chunks = 3